import styled, { css, keyframes } from 'styled-components';

import { BasicParagraph } from '../../../../../foundations/typefaces/BasicParagraph';
import style from '../../../../../style';

interface HorizontalMenuProps {
  $isActive?: boolean;
}

interface UnderlineProps extends HorizontalMenuProps {
  $hasAnimation?: boolean;
}

const menuActiveIn = () =>
  keyframes({
    '0%': {
      width: 0,
    },
    '100%': {
      width: '100%',
    },
  });

const menuActiveOut = () =>
  keyframes({
    '0%': {
      width: '100%',
    },
    '100%': {
      width: 0,
    },
  });

export const StyledIcon = styled.div<HorizontalMenuProps>(
  ({ theme: { size, color, transition }, $isActive }) => ({
    width: size.units(2),
    height: size.units(2),
    transition: transition.standard('color'),
    color: $isActive
      ? color.content.secondary.active()
      : color.content.secondary.default(),
  }),
);

export const StyledBasicParagraph = styled(BasicParagraph)<HorizontalMenuProps>(
  ({ theme: { color, font, transition }, $isActive }) => ({
    transition: transition.standard('color', 'fontWeight'),
    color: $isActive
      ? color.content.secondary.active()
      : color.content.secondary.default(),
    fontWeight: $isActive ? font.weight.bold : undefined,
  }),
);

export const Underline = styled.div<UnderlineProps>(
  ({ theme: { size, color } }) => ({
    height: size.units(0.25),
    backgroundColor: color.background.secondary.active(),
  }),
  ({ $isActive, $hasAnimation }) => css`
    animation: ${$isActive ? menuActiveIn : menuActiveOut} ${$hasAnimation ? 0.2 : 0}s
      cubic-bezier(0.4, 0, 0.4, 1) forwards;
  `,
);

export const Wrapper = styled.div(({ theme: { size, color } }) => ({
  width: 'auto',
  height: size.units(4),
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  padding: `${size.units(0.5)} ${size.units(0.5)} ${size.units(1)} ${size.units(0.5)}`,
  cursor: 'pointer',

  ...style.mixins.devices.desktop({
    '&:hover': {
      [`${StyledBasicParagraph}, ${StyledIcon}`]: {
        color: color.content.secondary.hover(),
      },
    },
  }),

  [Underline]: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
  },
}));
